<template>
    <b-container fluid class="p-0">
        <b-modal size="xl" show scrollable centered lazy :id="'my-modal-odb' + ElasticData._source.productReference " hide-footer>
            <template v-slot:modal-title>
                <span>{{ getString(mode+'_Title_Popup') }}</span>
            </template>
            <div v-html="getString(mode+'_Text_Popup')"></div>
            <div class="text-center my-2" v-if="loading===true">
                <div class="d-flex justify-content-center">
                    <b-spinner />
                    <div class="p-2">{{ getString('loading') }}</div>
                </div>
            </div>
            <validation-observer ref="searchRequestObserver" v-slot="{ passes }" v-else>
                <b-form class="mt-5" @submit.prevent="passes(sendMail)">
                    <b-form-group :label="getString('from')" label-for="txtFrom" label-cols="2" class="text-left">
                        <validation-provider rules="required|email" :name="getString('from')" v-slot="{ valid, errors }">
                            <b-form-input id="txtFrom" type="email" v-bind="$attrs" v-model="Email" maxlength="500" required
                                          :state="errors[0] ? false : (valid ? true : null)" :placeholder="getString('fromInput')">
                            </b-form-input>
                            <p v-for="error in errors">{{ error }}</p>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group :label="getString('title')" label-for="txtTitle" label-cols="2" class="text-left">
                        <validation-provider rules="required" :name="getString('title')" v-slot="{ valid, errors }">
                            <b-form-input id="txtTitle" type="text" disabled="true"
                                          v-model="ElasticData._source.distinctiveTitle" maxlength="500" required :state="errors[0] ? false : (valid ? true : null)" :placeholder="getString('titleInput')">
                            </b-form-input>
                            <p v-for="error in errors">{{ error }}</p>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group :label="getString('count')" label-for="txtCount" label-cols="2" class="text-left">
                        <validation-provider rules="required|numeric|between:1,1000000" :name="getString('count')" v-slot="{ valid, errors }">
                            <b-form-input id="txtCount" type="number" v-bind="$attrs" v-model.number="titleCount" min="1" max="1000000" :state="errors[0] ? false : (valid ? true : null)" :placeholder="getString('quantitiesInput')">
                            </b-form-input>
                            <p v-for="error in errors">{{ error }}</p>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group :label="getString('phone') + ' ' + getString('optionalField')" label-for="txtTelephone" label-cols="2" class="text-right">
                        <validation-provider :rules="{ regex:/^(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))$/ }" :name="getString('phone')" v-slot="{ valid, errors }">
                            <b-form-input id="txtTelephone" type="tel" v-bind="$attrs" v-model.trim="telephone" maxlength="25" :state="errors[0] ? false : (valid ? true : null)" :placeholder="getString('telephoneInput')">
                            </b-form-input>
                            <p v-for="error in errors">{{ error }}</p>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group :label="getString('comment') + ' (Nutzerangaben)'" label-for="txtComment" label-cols="2" class="text-right">
                        <b-form-textarea id="txtComment" type="text" v-bind="$attrs" v-model.trim="comment" maxlength="1024" placeholder="Nutzer 1: Name, Vorname, E-Mailadresse">
                        </b-form-textarea>
                    </b-form-group>
                    <div class="offset-2 d-flex flex-row">
                        <div class="d-flex flex-fill">
                            <b-button class="second-btn" @click="gotoAdvancedSearch()">{{getString(' Advanced search')}}</b-button>
                        </div>
                        <div class="d-flex justify-content-end">
                            <b-button type="submit" style="border:none;" class="first-btn">{{getString('Send')}}</b-button>
                            <b-button class="second-btn ml-2" @click="Cancel()">{{getString('Cancel')}}</b-button>
                        </div>
                    </div>
                </b-form>
            </validation-observer>
        </b-modal>
        <b-button class="first-btn" style="min-width: 100%; margin-bottom: 5px; border:none;"
                  v-b-modal="'my-modal-odb' + ElasticData._source.productReference " @click="getClientData()">{{ getString(mode+'_ButtonTextPopup') }}
        </b-button>
    </b-container>
</template>
<script>
    import MessageView from "@components/MessageView.vue";
    import ResourceHelper from "@common/globalization/ResourceHelper";
    export default {
        props: ['ElasticData', 'helpText','mode'],
        data() {
            return {
                messages: [],
                loading: false,
                from: "",
                telephone: "",
                Email: '',
                title: '',
                titleCount: '',
                searchRequest: {
                    title: '',
                }
            }
        },
        methods: {
            getString: function (name, defaultValue) {
                if (!name) return "";
                if (!defaultValue) defaultValue = "";
                return ResourceHelper.getString(name, defaultValue);
            },
            getClientData() {
                var url = GetDataFromHandler() + '1';
                var refToThis = this;
                axios({
                    method: 'get',
                    url: url,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                    }
                }).then(function (result) {
                    refToThis.Email = result.data.Email;
                });
            },
            sendMail() {
                
                this.loading = true;
                // call mail service ;
                var ref = this;
                let modelName = 'my-modal-odb' + this.ElasticData._source.productReference;
                const data = {
                    from: this.Email,
                    title: this.ElasticData._source.distinctiveTitle,
                    searchKeyword: this.ElasticData._source.distinctiveTitle,
                    isbn: this.ElasticData._source.productReference,
                    price: this.ElasticData._source.finalPrice.priceAmount,
                    publisher: this.ElasticData._source.publisher ? this.ElasticData._source.publisher : "",
                    titleCount: this.titleCount,
                    telephone: this.telephone,
                    comment: this.comment
                };
                var url = GetDataFromHandler() + (this.mode == "ODB" ? '3' : '4');
                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                    }
                }).then(function (result) {
                    ref.loading = false;
                    ref.$root.$emit('bv::hide::modal', modelName, '#btnShow');
                });
            },
            gotoAdvancedSearch() {
                const advUrl = getDetailPageUrl() || '';
                if (!advUrl) return;
                window.location.href = advUrl;
            }
            , Cancel() {
                let modelName = 'my-modal-odb' + this.ElasticData._source.productReference;
                this.$root.$emit('bv::hide::modal', modelName, '#btnShow');
            }
        },
        components: {
            MessageView
        }
    }
</script>
<style lang="css" scoped>
    @import "~css/common.css";
    @import "~css/bootstrap.css";

    p {
        margin: 0 !important;
    }
</style>